import * as React from 'react';
import { TextField, IconButton, InputLabel, FormHelperText } from '@mui/material';
import { FileUploadOutlined } from "@mui/icons-material";
import { TypingValidateEmail } from '../../../util/General';

export const Email = ({ id, value, updateValue, path, description, errors, visible, label }) => {
  // console.log('value', value)
  const [validationError, setValidationError] = React.useState('')
  const [touched, setTouched] = React.useState(false)

  const handleChange = (event) => {
    let initialValue = event.target.value;
    const data = TypingValidateEmail(initialValue);
    updateValue(data);
    if (!data.is_valid) {
      setValidationError('Not a valid email address')
    } else {
      setValidationError('')
    }
  };

  const handleTouch = () => {
    setTouched(true);
  };

  const handleTouchOut = () => {
    setTouched(false);
  };

  return (
    <div id={`#/properties/${path}`} className={path} style={{ display: visible ? 'block' : 'none' }}>
      <TextField
        variant="standard"
        type="email"
        value={value?.value ?? ''}
        fullWidth={true}
        style={{ marginBottom: errors ? '0px' : undefined }}
        error={errors || validationError ? true : false}
        label={label}
        helperText={validationError ? validationError : touched && description}
        onChange={handleChange}
        onFocus={handleTouch}
        onBlur={handleTouchOut}
      />
      { errors &&
        <FormHelperText error={true} filled={true}>{errors}</FormHelperText>
      }
    </div>
  );
};
